import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=234c0a2a&"
import script from "./frame.vue?vue&type=script&lang=js&"
export * from "./frame.vue?vue&type=script&lang=js&"
import style0 from "./frame.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234c0a2a')) {
      api.createRecord('234c0a2a', component.options)
    } else {
      api.reload('234c0a2a', component.options)
    }
    module.hot.accept("./frame.vue?vue&type=template&id=234c0a2a&", function () {
      api.rerender('234c0a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frame/frame.vue"
export default component.exports